import { useCallback, useState } from "react";

import { useKeystone, useSelectedPolicy } from "data/ss-data-hooks";
import { UnauthorizedRequestError, isError } from "data/ss-error";
import { type WindDefenseContextState } from "pages/offer/wind-defense/wind-defense-flow";
import { handleUnauthorized } from "utils";

export type WindDefenseEnrollmentValues = {
  offeringId?: string;
  offerId?: string;
  insightPolicyId?: string;
  additionalDetails?: {
    firstName?: string;
    lastName?: string;
    emailAddress?: string;
    phone?: string;
  };
};

export const useWindDefenseEnrollment = (state: WindDefenseContextState) => {
  const keystone = useKeystone();
  const { data } = useSelectedPolicy();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { firstName, lastName, emailAddress, phone, offeringId, offerId } =
    state ?? {};

  const enrollWindDefense = useCallback(async () => {
    setLoading(true);
    setError(false);
    const windDefenseEnrollmentBody: WindDefenseEnrollmentValues = {
      offeringId,
      offerId,
      insightPolicyId: data?.keystonePolicyId,
      additionalDetails: {
        firstName,
        lastName,
        emailAddress,
        phone,
      },
    };

    const response = await keystone.enrollWindDefense(
      windDefenseEnrollmentBody
    );
    if (isError(response)) {
      if (response instanceof UnauthorizedRequestError) {
        handleUnauthorized({ endpoint: "homeservices/order/winddefense" });
      } else {
        setError(true);
      }
    }
    setLoading(false);

    return !isError(response);
  }, [
    emailAddress,
    firstName,
    keystone,
    lastName,
    offerId,
    offeringId,
    phone,
    data?.keystonePolicyId,
  ]);

  return { enrollWindDefense, loading, error };
};
